module.exports = __webpack_public_path__ + "static/media/calculator.4cb0d520.svg";